import script from "./WageCalc.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageCalc.vue?vue&type=script&setup=true&lang=ts"

import "./WageCalc.vue?vue&type=style&index=0&id=352beff8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352beff8"]])

export default __exports__